import React from 'react'

interface VerifiedIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const VerifiedIcon: React.FC<VerifiedIconProps> = ({
  color = '#000',
  gradient,
  width = 16,
  height = 16,
  alt = 'Verified icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 16 16'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        d='M15.645 6.992L14.557 5.73a1.772 1.772 0 01-.376-1.008V3.36a1.55 1.55 0 00-1.544-1.543h-1.36c-.312 0-.768-.168-1.008-.376L9.005.354c-.552-.472-1.457-.472-2.017 0L5.732 1.45c-.24.2-.696.368-1.008.368H3.34A1.55 1.55 0 001.796 3.36V4.73c0 .312-.168.76-.368 1L.348 7c-.464.552-.464 1.448 0 2l1.08 1.271c.2.24.368.688.368 1v1.368a1.55 1.55 0 001.544 1.543h1.384c.312 0 .768.168 1.008.376l1.264 1.088c.552.472 1.457.472 2.017 0l1.264-1.088c.24-.208.688-.376 1.008-.376h1.36a1.55 1.55 0 001.544-1.543v-1.36c0-.312.168-.768.376-1.008l1.088-1.263c.464-.552.464-1.464-.008-2.016zm-4.32-.504L7.46 10.351a.6.6 0 01-.848 0L4.676 8.416a.603.603 0 010-.848.604.604 0 01.848 0L7.036 9.08l3.44-3.44a.604.604 0 01.849 0 .603.603 0 010 .848z'
      ></path>
    </svg>
  )
}

export default VerifiedIcon
